<template>
  <base-modal
    :reference="'addNewBus'"
    :title="'Añadir nuevo bus'"
    :acceptAction="addBus"
    :cancelActionText="'Cerrar'"
    :size="'md'"
  >
    <template v-slot:body v-if="show">
      <div class="d-block ">
        <form>
          <div class="d-flex justify-content-center w-100 mt-4">
            <div class="d-flex flex-column align-items-sm-baseline">
              <label>Nombre *</label>
              <b-form-input 
                style="width: 17vw; border: 1px solid #999 !important;" 
                v-model="nameBus" 
                placeholder="Inserte nombre bus">
              </b-form-input>
              <span v-if="nameBus == ''" class="text-danger font-weight-bold">
                El nombre és obligatorio
              </span>
            </div>
          </div>
          <div class="d-flex justify-content-center w-100 mt-4">
            <div class="d-flex flex-column align-items-sm-baseline">
              <label>Plazas *</label>
              <b-form-input
                style="width: 17vw; border: 1px solid #999 !important;"
                v-model="maxSizeBus"
                placeholder="Inserte número de plazas"
              ></b-form-input>
              <span v-if="maxSizeBus == ''" class="text-danger font-weight-bold">
                El número de plazas és obligatorio
              </span>
            </div>
          </div>
          <div class="d-flex justify-content-center w-100 mt-4">
            <div class="d-flex flex-column align-items-sm-baseline">
              <label>Número de bus</label>
              <b-form-input
                style="width: 17vw; border: 1px solid #999 !important;"
                v-model="numberBus"
                type="number"
                placeholder="Inserte número bus"
              ></b-form-input>
            </div>
          </div>
          <div class="d-flex justify-content-center w-100 mt-4">
            <div class="d-flex flex-column align-items-sm-baseline">
              <label>Nombre de la compañía de buses</label>
              <b-form-select
                v-model="bus_company"
                style="width: 17vw;"
              >
                <option :value="0">Seleccione una compañía de buses</option>
                <option
                  v-for="company in busCompanies"
                  :key="company.id"
                  :label="company.name"
                  :value="company.id"
                >
                  {{ company.full_name }}
                </option>
              </b-form-select>
            </div>
          </div>
          <div class="d-flex justify-content-center w-100 mt-4">
            <div class="d-flex flex-column align-items-sm-baseline" style="width: 17vw;">
              <label>Tarifa de bus</label>
              <b-form-select
                v-model="bus_fare_type"
                style="width: 17vw;"
              >
                <option :value="0">Seleccione una tarifa de bus</option>
                <option
                  v-for="fare in busFareTypes"
                  :key="fare.id"
                  :label="fare.name"
                  :value="fare.id"
                >
                  {{ fare.name }}
                </option>
              </b-form-select>
            </div>
          </div>
          <div class="d-flex justify-content-center w-100 mt-4">
            <div class="d-flex flex-column align-items-sm-baseline" style="width: 17vw;">
              <label>Usos del bus *</label>
              <b-form-checkbox
                  :id="'used_excursion'"
                  v-model="used_excursion"
                  :name="'used_excursion'"
                  class="my-2"
              >
                  Usado para excursión
              </b-form-checkbox>

              <b-form-checkbox
                  :id="'used_pickup'"
                  v-model="used_pickup"
                  :name="'used_pickup'"
                  class="my-2"
              >
                  Usado para recogidas
              </b-form-checkbox>

              <b-form-checkbox
                  :id="'used_return'"
                  v-model="used_return"
                  :name="'used_return'"
                  class="my-2"
              >
                  Usado para dejadas
              </b-form-checkbox>
              <span v-if="!used_excursion && !used_pickup && !used_return" class="alert-danger alert font-weight-bold">
                Al menos uno de los checks tiene que estar marcado
              </span>
            </div>
           
          </div>
        </form>
      </div>
    </template>
    
  </base-modal>
  
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import BaseModal from '../../../Excursions/Booking/Modal/BaseModal';

export default {
  components: {
      BaseModal,
  },
  props: {},
  data() {
    return {
      nameBus: "",
      sizeBus: "",
      maxSizeBus: "",
      numberBus: null,
      used_excursion: false,
      used_pickup: false,
      used_return: false,
      bus_company: null,
      bus_fare_type: null,
      colors: [
        "#a8c1de",
        "#0000ff",
        "#ff0000",
        "#3771f8",
        "#e23193",
        "#236134",
        "#00b7e6",
        "#fc6512",
        "#28a0e5",
        "#880a56",
        "#c6ac55",
        "#af9c75",
        "#abbdf7",
        "#d454ed",
        "#c5c7d5",
        "#2ee2f0",
        "#41946d",
        "#fbe4f4",
        "#879598",
        "#9b496b",
        "#fa7d97",
        "#30886b",
        "#58678a",
        "#fc044c",
        "#ea61d0",
        "#7ac646",
        "#446ea8",
        "#b73a00",
        "#a7686e",
      ],
      show: false,
    };
  },
  async mounted() {
    
    this.$root.$on('bv::modal::show', async (bvEvent, modalId) => {
      if ( modalId === 'addNewBus' ) {
        this.$store.dispatch("buscompanies/retrieveBusCompanies")
        this.$store.dispatch("busFareTypes/retrieveBusFareTypes")
        this.show = true
      }
      
    })
  },
  methods: {
    async addBus() {
      if ((!this.used_excursion && !this.used_pickup && !this.used_return) || this.nameBus == '' || this.maxSizeBus == '') {
        this.$notify({
          group: "foo",
          title: "Datos incompletos",
          text: "No se puede crear el nuevo bus por falta de datos",
          type: "error"
        });
        return
      }
      let rand = this.colors[Math.floor(Math.random() * this.colors.length)];

      let allBuses = this.$store.getters.buses;
      for (let i = 0; i < allBuses.length; i++) {
        const element = allBuses[i];
        if (element.color == rand) {
          rand = this.colors[Math.floor(Math.random() * this.colors.length)];
          i = 0
        }
      }

      let busData = {
        name: this.nameBus,
        max_size: this.maxSizeBus,
        color_code: rand,
        day: this.$store.getters.filterDate,
        activity_group: this.$store.getters.filterGroup,
        used_excursion: this.used_excursion,
        used_pickup: this.used_pickup,
        used_return: this.used_return,
        bus_company: this.bus_company,
        bus_fare_type: this.bus_fare_type
      };
      if ( this.numberBus != null && this.numberBus != undefined) {
        busData.number = this.numberBus
      }

      try{
        await this.$store.dispatch("buses/addNewBus", busData)
          
        this.nameBus = "";
        this.sizeBus = "";
        this.maxSizeBus = "";
        this.numberBus = null;
        this.bus_fare_type = null
        this.bus_company = null
        this.used_excursion = false
        this.used_pickup = false
        this.used_return = false
        
        this.$notify({
          group: "foo",
          title: "Bus creado",
          text: "Se ha creado con éxito un nuevo bus",
          type: "success"
        });
        this.$bvModal.hide('addNewBus');

      } catch ( error ) {
        console.log(error)
        this.$notify({
          group: "foo",
          title: "Error en los datos",
          text: "Por favor, revise los datos " + error.error,
          type: "error"
        });
      }      
    },
  },
  computed: {
    ...mapGetters(["activeTab", "busCompanies", "busFareTypes"]),
  }
};
</script>
